/** EmptyState — reusable empty state component with icon, title, description, and optional action. */

import type { ReactNode, CSSProperties } from "react";
import styles from "../../styles/matter.module.css";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  style?: CSSProperties;
}

export default function EmptyState({
  icon,
  title,
  description,
  action,
  style,
}: EmptyStateProps) {
  return (
    <div className={styles.emptyState} style={style}>
      {icon && <div className={styles.emptyIcon}>{icon}</div>}
      <div className={styles.emptyTitle}>{title}</div>
      {description && (
        <div className={styles.emptyDescription}>{description}</div>
      )}
      {action}
    </div>
  );
}
